module.exports = __webpack_public_path__ + "static/img/close.34a373f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn/close.png
// module id = 1l/W
// module chunks = 1